/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-multi-str */
export const ACTIVE_SUBS_MODAL_WARNING = 'You are already subscribed to a membership at this level or higher.';

export const TIER_DESCRIPTIONS = {
  ENTRY: 'ENTRY',
  CORE: 'CORE',
  PRO: 'PRO',
  ULTIMATE: 'ULTIMATE',
};

export const MEMBERSHIP_STATUSES = {
  SUBSCRIBED: 'subscribed',
  PENDING: 'subscriptionpending',
  CANCELLED: 'cancelled',
  NONRENEW: 'nonrenew',
  EXPIRED: 'expired',
};

export const PLAN_ID = {
  coreMonthly: process.env.REACT_APP_FS_CORE_MONTHLY_PLAN,
  coreAnnual: process.env.REACT_APP_FS_CORE_ANNUAL_PLAN,
  proMonthly: process.env.REACT_APP_FS_PRO_MONTHLY_PLAN,
  proAnnual: process.env.REACT_APP_FS_PRO_ANNUAL_PLAN,
  proP4L: process.env.REACT_APP_FS_PRO_P4L_PLAN,
  ultimateMonthly: process.env.REACT_APP_FS_ULTIMATE_MONTHLY_PLAN,
  ultimateAnnual: process.env.REACT_APP_FS_ULTIMATE_ANNUAL_PLAN,
  ultimateP4L: process.env.REACT_APP_FS_ULTIMATE_P4L_PLAN,
  threeMonths: process.env.REACT_APP_FS_THREE_MONTHS_PLAN,
};

export const FREE_LABEL = {
  en: {
    label: 'FREE',
  },
  es: {
    label: 'GRATIS',
  },
  cs: {
    label: 'ZDARMA',
  },
  de: {
    label: 'KOSTENLOS',
  },
  da: {
    label: 'GRATIS',
  },
  fi: {
    label: 'ILMAISEKSI',
  },
  fr: {
    label: 'GRATUIT',
  },
  hu: {
    label: 'INGYENES',
  },
  it: {
    label: 'GRATIS',
  },
  ja: {
    label: '無料',
  },
  nl: {
    label: 'GRATIS',
  },
  no: {
    label: 'GRATIS',
  },
  pl: {
    label: 'DARMOWE',
  },
  pt: {
    label: 'OFERTA',
  },
  ro: {
    label: 'GRATUIT',
  },
  sv: {
    label: 'GRATIS',
  },
  sk: {
    label: 'ZDARMA',
  },
};

export const MEMBERSHIPS_ACTIONS = {
  en: {
    active: 'ACTIVE',
    unavailable: 'UNAVAILABLE',
    upgrade: 'UPGRADE NOW',
    purchasable: 'JOIN NOW',
    getStarted: 'GET STARTED',
  },
  es: {
    active: 'ACTIVA',
    unavailable: 'NO DISPONIBLE',
    upgrade: 'MEJORA AHORA',
    purchasable: 'ÚNETE AHORA',
    getStarted: 'EMPEZAR',
  },
  cs: {
    active: 'AKTIVNÍ',
    unavailable: 'NEDOSTUPNÉ',
    upgrade: 'UPGRADE NYNÍ',
    purchasable: 'PŘIDEJ SE NYNÍ',
    getStarted: 'ZAČÍT',
  },
  de: {
    active: 'AKTIV',
    unavailable: 'NICHT VERFÜGBAR',
    upgrade: 'UPGRADE',
    purchasable: 'JETZT KAUFEN',
    getStarted: 'ERSTE SCHRITTE',
  },
  da: {
    active: 'AKTIV',
    unavailable: 'UTILGÆNGELIG',
    upgrade: 'OPGRADER NU',
    purchasable: 'TILMELD DIG NU',
    getStarted: 'KOM I GANG',
  },
  fi: {
    active: 'AKTIIVINEN',
    unavailable: 'EI SAATAVILLA',
    upgrade: 'PÄIVITÄ NYT',
    purchasable: 'LIITY NYT',
    getStarted: 'ALOITA TÄSTÄ',
  },
  fr: {
    active: 'ACTIF',
    unavailable: 'INDISPONIBLE',
    upgrade: 'NIVEAU SUPÉRIEUR',
    purchasable: 'ACHETER MAINTENANT',
    getStarted: 'DÉMARRAGE',
  },
  hu: {
    active: 'AKTÍV',
    unavailable: 'NEM ELÉRHETŐ',
    upgrade: 'FRISSÍTS MOST',
    purchasable: 'CSATLAKOZZ MOST',
    getStarted: 'KEZDJ HOZZÁ',
  },
  it: {
    active: 'ATTIVA',
    unavailable: 'NON DISPONIBILE',
    upgrade: 'AGGIORNA ORA',
    purchasable: 'COMPRA ORA',
    getStarted: 'PER INIZIARE',
  },
  ja: {
    active: '有効',
    unavailable: '利用不可',
    upgrade: 'アップグレード',
    purchasable: '今すぐ購入',
    getStarted: 'はじめよう',
  },
  nl: {
    active: 'ACTIEF',
    unavailable: 'NIET BESCHIKBAAR',
    upgrade: 'UPGRADE',
    purchasable: 'KOOP NU',
    getStarted: 'AAN DE SLAG',
  },
  no: {
    active: 'AKTIV',
    unavailable: 'UTILGJENGELIG',
    upgrade: 'OPPDATER NÅ',
    purchasable: 'BLI MED NÅ',
    getStarted: 'KOM I GANG',
  },
  pl: {
    active: 'AKTYWNY',
    unavailable: 'NIEDOSTĘPNY',
    upgrade: 'AKTUALIZACJA',
    purchasable: 'KUP TERAZ',
    getStarted: 'ZACZYNAJMY',
  },
  pt: {
    active: 'ATIVO',
    unavailable: 'INDISPONÍVEL',
    upgrade: 'ATUALIZAR AGORA',
    purchasable: 'COMPRAR AGORA',
    getStarted: 'VAMOS COMEÇAR',
  },
  ro: {
    active: 'ACTIV',
    unavailable: 'INDISPONIBIL',
    upgrade: 'UPGRADE ACUM',
    purchasable: 'ÎNSCRIE-TE ACUM',
    getStarted: 'ÎNCEPE',
  },
  sv: {
    active: 'AKTIV',
    unavailable: 'OTILLGÄNGLIG',
    upgrade: 'UPPGRADERA NU',
    purchasable: 'GÅ MED NU',
    getStarted: 'KOM IGÅNG',
  },
  sk: {
    active: 'AKTÍVNY',
    unavailable: 'NEDOSTUPNÝ',
    upgrade: 'UPGRADE TERAZ',
    purchasable: 'PRIDAJ SA TERAZ',
    getStarted: 'ZAČAŤ',
  },
};

export const MEMBERSHIPS = {
  en: [
    {
      name: FREE_LABEL.en.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.en.getStarted,
      features: [
        'Zenbeats',
        'ZENOLOGY Lite',
        'Ability to purchase Lifetime Keys',
        'Companion apps and content for Compatible Roland Hardware',
      ],
      seeMoreLabel: 'More on Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.en.purchasable,
      features: [
        'Zenbeats MAX',
        'ZENOLOGY Software Synthesizer ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Compare Memberships',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.en.purchasable,
      features: [
        'ZENOLOGY Pro',
        'Legendary Sound Packs, Samples, Jam Tracks',
        'Access to 2 Legendary Instruments at a time',
      ],
      seeMoreLabel: 'Compare Memberships',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.en.purchasable,
      features: [
        'GALAXIAS',
        'Early access to certain products via Ultimate Early Access',
        'All Software Effects including Boss Effects Pedals & JC-120',
        'All Software Instruments and Sounds',
      ],
      seeMoreLabel: 'Compare Memberships',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  es: [
    {
      name: FREE_LABEL.es.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.es.getStarted,
      features: [
        'Sintetizador de software ZENOLOGY Lite',
        'Zenbeats MAX',
        'Posibilidad de comprar y Lifetime Keys',
        'Apps y contenido complementarios para productos físicos Roland compatibles',
      ],
      seeMoreLabel: 'Más sobre las Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.es.purchasable,
      features: [
        'Sintetizador de software ZENOLOGY y Sound Packs ',
        'ZENOLOGY FX ',
        'Colecciones SDZ y EXZ',
      ],
      seeMoreLabel: 'Comparar suscripciones',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.es.purchasable,
      features: [
        'Sintetizador de software ZENOLOGY Pro y Model Expansions',
        'Sound Packs, muestras y Jam Tracks gratuitos',
        'Acceso simultáneo a dos instrumentos Legendary',
      ],
      seeMoreLabel: 'Comparar suscripciones',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.es.purchasable,
      features: [
        'GALAXIAS',
        'Acceso anticipado a determinados productos mediante Ultimate Early Access',
        'Todos los sonidos e instrumentos de software',
      ],
      seeMoreLabel: 'Comparar suscripciones',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  cs: [
    {
      name: FREE_LABEL.cs.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.cs.getStarted,
      features: [
        'ZENOLOGY Lite Software Synthesizer',
        'Zenbeats MAX',
        'Možnost nákupu licencí Lifetime Keys',
        'Doprovodné aplikace a obsah pro kompatibilní hardware Roland',
      ],
      seeMoreLabel: 'Více informací o licencích Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.cs.purchasable,
      features: [
        'ZENOLOGY Software Synthesizer',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Porovnat drhy členství',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.cs.purchasable,
      features: [
        'ZENOLOGY Pro Software Synthesizer & Model Expansions',
        'Bezplatné balíčky Sound Packs, samply, jam tracky',
        'Přístup ke 2 nástrojům Legendary najednou',
      ],
      seeMoreLabel: 'Porovnat drhy členství',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.cs.purchasable,
      features: [
        'GALAXIAS',
        'Předčasný přístup k některým produktům prostřednictvím služby Ultimate Early Access',
        'Všechny softwarové nástroje a zvuky',
      ],
      seeMoreLabel: 'Porovnat drhy členství',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  de: [
    {
      name: FREE_LABEL.de.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.de.getStarted,
      features: [
        'ZENOLOGY Lite Software Synthesizer ',
        'Zenbeats MAX',
        'Optionaler Kauf von Lifetime Keys',
        'Begleitapps und Inhalte für kompatible Roland Hardware',
      ],
      seeMoreLabel: 'Weitere Informationen zu den Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.de.purchasable,
      features: [
        'ZENOLOGY Software Synthesizer ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Mitgliedschaften vergleichen',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.de.purchasable,
      features: [
        'ZENOLOGY Pro Software-Synthesizer & Model Expansions',
        'Kostenlose Sound Packs, Samples, Jam Tracks',
        'Gleichzeitiger Zugang zu zwei Legendary Instrumenten',
      ],
      seeMoreLabel: 'Mitgliedschaften vergleichen',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.de.purchasable,
      features: [
        'GALAXIAS',
        'Frühzeitiger Zugang zu bestimmten Produkten via Ultimate Early Access',
        'Alle Software-Instrumente und Sounds',
      ],
      seeMoreLabel: 'Mitgliedschaften vergleichen',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  da: [
    {
      name: FREE_LABEL.da.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.da.getStarted,
      features: [
        'ZENOLOGY Lite Software Synthesiser',
        'Zenbeats MAX',
        'Mulighed for køb og Lifetime Keys',
        'Ledsagende apps og indhold til kompatibel Roland-hardware',
      ],
      seeMoreLabel: 'Mere om Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.da.purchasable,
      features: [
        'ZENOLOGY Software Synthesizer ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'er',
      ],
      seeMoreLabel: 'Sammenlign medlemskaber',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.da.purchasable,
      features: [
        'ZENOLOGY Pro Software Synthesizer & Model-udvidelser ',
        'Gratis lydpakker, prøver, jamtracks ',
        'Adgang til 2 legendariske instrumenter ad gangen ',
      ],
      seeMoreLabel: 'Sammenlign medlemskaber ',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.da.purchasable,
      features: [
        'GALAXIAS',
        'Tidlig adgang til visse produkter via Ultimate Early Access ',
        'Alle softwareinstrumenter og -lyde ',
      ],
      seeMoreLabel: 'Sammenlign medlemskaber ',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  fi: [
    {
      name: FREE_LABEL.fi.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.fi.getStarted,
      features: [
        'ZENOLOGY Lite -softasyntikka',
        'Zenbeats MAX',
        'Oikeus ostaa Lifetime Key -lisenssejä',
        'Kumppanisovellukset sekä sisältöä yhteensopiville Roland hardware -soittimille',
      ],
      seeMoreLabel: 'Lisää Lifetime Key -lisensseistä',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fi.purchasable,
      features: [
        'ZENOLOGY -softasyntikka & Sound Pack -laajennukset',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ-laajennukset',
      ],
      seeMoreLabel: 'Vertaile jäsenyyksiä',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fi.purchasable,
      features: [
        'ZENOLOGY Pro Softasyntikka & Model Expansion -laajennukset',
        'Ilmaisia Sound Pack -laajennuksia, sampleja, Jam Track -raitoja',
        'Käyttöoikeus kahteen Legendary Instruments:iin kerrallaan',
      ],
      seeMoreLabel: 'Vertaile jäsenyyksiä',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fi.purchasable,
      features: [
        'GALAXIAS',
        'Aikaisempi käyttöoikeus joihinkin tuotteisiin Ultimate Early Access:illa',
        'Kaikki softa-instrumentit ja soundit',
      ],
      seeMoreLabel: 'Vertaile jäsenyyksiä',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  fr: [
    {
      name: FREE_LABEL.fr.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.fr.getStarted,
      features: [
        'Synthétiseur logiciel Zenology Lite',
        'Zenbeats MAX',
        'Capacité à acheter et Lifetime Keys',
        'Applis compagnons et contenus pour les instruments matériels Roland compatibles',
      ],
      seeMoreLabel: 'À propos des Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fr.purchasable,
      features: [
        'Synthétiseur logiciel ZENOLOGY & Packs de sons',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ',
      ],
      seeMoreLabel: 'Comparer les abonnements',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fr.purchasable,
      features: [
        'Synthétiseur logiciel ZENOLOGY Pro & Extensions de modélisation',
        'Packs de sons, d\'échantillons et de Jam Tracks gratuits',
        'Accès à deux instruments Legendary en même temps',
      ],
      seeMoreLabel: 'Comparer les abonnements',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.fr.purchasable,
      features: [
        'GALAXIAS',
        'Accès anticipé à certains produits via Ultimate Early Access',
        'Tous les instruments logiciels et les sons',
      ],
      seeMoreLabel: 'Comparer les abonnements',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  hu: [
    {
      name: FREE_LABEL.hu.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.hu.getStarted,
      features: [
        'ZENOLOGY Lite Software Synthesizer',
        'Zenbeats MAX',
        'Vásárlási lehetőség és Lifetime Key opciók',
        'Kiegészítő alkalmazások és tartalmak a kompatibilis Roland hardverekhez',
      ],
      seeMoreLabel: 'További Lifetime Key információk',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.hu.purchasable,
      features: [
        'ZENOLOGY Software Synthesizer',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ',
      ],
      seeMoreLabel: 'Hasonlítsd össze a tagságokat',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.hu.purchasable,
      features: [
        'ZENOLOGY Pro Software Synthesizer & Model Expansions',
        'Ingyenes hangszíncsomagok, hangminták és kíséretek',
        'Két legendás hangszer egyidejű elérése',
      ],
      seeMoreLabel: 'Hasonlítsd össze a tagságokat',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.hu.purchasable,
      features: [
        'GALAXIAS',
        'dő előtti hozzáférés bizonyos termékekhez az Ultimate Early Access segítségével.',
        'Minden szoftveres hangszer és hangszín',
      ],
      seeMoreLabel: 'Hasonlítsd össze a tagságokat',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  it: [
    {
      name: FREE_LABEL.it.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.it.getStarted,
      features: [
        'Sintetizzatore software ZENOLOGY Lite ',
        'Zenbeats MAX',
        'Possibilità di effettuare acquisti e Lifetime Key',
        'App dedicate e contenuti per l\'Hardware Roland compatibile',
      ],
      seeMoreLabel: 'Maggiori informazioni sulle Lifetime Key',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.it.purchasable,
      features: [
        'Sintetizzatore Software ZENOLOGY & Sound Pack',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ',
      ],
      seeMoreLabel: 'Compara gli abbonamenti',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.it.purchasable,
      features: [
        'Sintetizzatore Software ZENOLOGY Pro & Model Expansion',
        'Sound Pack, Sample, Jam Track gratuiti',
        'Accesso a 2 Legendary Instrument alla volta',
      ],
      seeMoreLabel: 'Compara gli abbonamenti',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.it.purchasable,
      features: [
        'GALAXIAS',
        'Accesso anticipato a determinati prodotti tramite Ultimate Early Access',
        'Tutti gli Strumenti Software e i Suoni',
      ],
      seeMoreLabel: 'Compara gli abbonamenti',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  ja: [
    {
      name: FREE_LABEL.ja.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.ja.getStarted,
      features: [
        'ZENOLOGY Lite ソフトウェア・シンセサイザー',
        'Zenbeats MAX',
        'Lifetime Key の購入',
        '対応する Roland ハードウェア製品向け専用アプリとコンテンツ',
      ],
      seeMoreLabel: 'Lifetime Key について',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ja.purchasable,
      features: [
        'ZENOLOGY ソフトウェア・シンセサイザーおよびサウンド・パック',
        'ZENOLOGY FX ',
        'SDZ および EXZ',
      ],
      seeMoreLabel: 'メンバーシップの比較',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ja.purchasable,
      features: [
        'ZENOLOGY Pro ソフトウェア・シンセサイザーおよび Model Expansion',
        '各種サウンド・パック、サンプル、Jam Tracks',
        'Legendary シリーズのインストゥルメントから２つまで同時アクセス',
      ],
      seeMoreLabel: 'メンバーシップの比較',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ja.purchasable,
      features: [
        'GALAXIAS',
        'Ultimate Early Access による特定製品への早期アクセス',
        'BOSS Effects Pedals および JC-120 を含むすべてのソフトウェア・エフェクト',
        'すべてのソフトウェア・インストゥルメントとサウンド',
      ],
      seeMoreLabel: 'メンバーシップの比較',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  nl: [
    {
      name: FREE_LABEL.nl.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.nl.getStarted,
      features: [
        'ZENOLOGY Lite Software Synthesizer ',
        'Zenbeats MAX',
        'Mogelijkheid om te kopen en Lifetime Keys',
        'Companion apps en content voor Compatibele Roland Hardware ',
      ],
      seeMoreLabel: 'Meer over Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.nl.purchasable,
      features: [
        'ZENOLOGY Software Synthesizer ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Vergelijk Lidmaatschappen',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.nl.purchasable,
      features: [
        'ZENOLOGY Pro Software Synthesizer & Model Expansions',
        'Gratis Sound Packs, Samples, Jam Tracks',
        'Toegang tot twee Legendary Instruments tegelijk',
      ],
      seeMoreLabel: 'Vergelijk Lidmaatschappen',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.nl.purchasable,
      features: [
        'GALAXIAS',
        'Vervroegde toegang tot bepaalde producten via Ultimate Early Access',
        'Alle software instrumenten en sounds',
      ],
      seeMoreLabel: 'Vergelijk Lidmaatschappen',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  no: [
    {
      name: FREE_LABEL.nl.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.no.getStarted,
      features: [
        'ZENOLOGY Lite programvaresynthesizer',
        'Zenbeats MAX',
        'Mulighet til å kjøpe Lifetime Keys',
        'Tilhørende app og innhold for kompatible Roland-enheter',
      ],
      seeMoreLabel: 'Mer om Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.no.purchasable,
      features: [
        'ZENOLOGY programvaresynthesizer og lydpakker ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Sammenlign medlemskap',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.no.purchasable,
      features: [
        'ZENOLOGY Pro programvaresynthesizer og model expansions',
        'Gratis lydpakker, samples, jam-låters',
        'Tilgang til to Legendary-instrumenter av gangen',
      ],
      seeMoreLabel: 'Sammenlign medlemskap',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.no.purchasable,
      features: [
        'GALAXIAS',
        'Tidlig tilgang til visse produkter via Ultimate Early Access',
        'Alle programvareinstrumenter og lyder',
      ],
      seeMoreLabel: 'Sammenlign medlemskap',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  pl: [
    {
      name: FREE_LABEL.pl.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.pl.getStarted,
      features: [
        'Syntezator Programowy ZENOLOGY Lite',
        'Zenbeats MAX',
        'Możliwość zakupu i Lifetime Keys',
        'Aplikacje towarzyszące i treści dla kompatybilnego sprzętu Roland',
      ],
      seeMoreLabel: 'Więcej Informacji o Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pl.purchasable,
      features: [
        'Syntezator Programowy ZENOLOGY i Pakiety Dźwięków ',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Porównanie Członkostw',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pl.purchasable,
      features: [
        'Syntezator Programowy ZENOLOGY Pro i Model Expansions',
        'Darmowe Pakiety Dźwiękowe, Sample, Jam Tracks',
        'Dostęp do 2 Legendary Instruments jednocześnie',
      ],
      seeMoreLabel: 'Porównanie Członkostw',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pl.purchasable,
      features: [
        'GALAXIAS',
        'Wczesny dostęp do niektórych produktów za pośrednictwem Ultimate Early Access',
        'Wszystkie Instrumenty Programowe i Dźwięki',
      ],
      seeMoreLabel: 'Porównanie Członkostw',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  pt: [
    {
      name: FREE_LABEL.pt.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.pt.getStarted,
      features: [
        'Sintetizador de software ZENOLOGY Lite',
        'Zenbeats MAX',
        'Possibilidade de adquirir chaves vitalícias',
        'Aplicações e conteúdos complementares para hardware Roland compatível',
      ],
      seeMoreLabel: 'Mais sobre as Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pt.purchasable,
      features: [
        'ZENOLOGY Software Sintetizador e Pacotes de Sons',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Comparar associações',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pt.purchasable,
      features: [
        'ZENOLOGY Pro Software Sintetizador e Expansões de Modelo',
        'Pacotes de sons, samples e faixas de músicas grátis',
        'Acesso a 2 instrumentos lendários de cada vez',
      ],
      seeMoreLabel: 'Comparar associações',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.pt.purchasable,
      features: [
        'GALAXIAS',
        'Acesso antecipado a determinados produtos através do Acesso Antecipado Ultimate',
        'Todos os instrumentos e sons de software',
      ],
      seeMoreLabel: 'Comparar associações',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  ro: [
    {
      name: FREE_LABEL.ro.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.ro.getStarted,
      features: [
        'Sintetizatorul Software ZENOLOGY Lite',
        'Zenbeats MAX',
        'Posibilitatea de a cumpăra și Lifetime Keys',
        'Aplicații însoțitoare și conținut pentru Hardware Roland compatibil',
      ],
      seeMoreLabel: 'Mai multe despre Lifetime Keys',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ro.purchasable,
      features: [
        'Sintetizator Software ZENOLOGY Pro și Pachete de Sunete',
        'ZENOLOGY FX ',
        'SDZ, ZEZ & EXZ\'s',
      ],
      seeMoreLabel: 'Comparați Abonamentele',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ro.purchasable,
      features: [
        'Sintetizator Software ZENOLOGY Pro și Expansiuni de Modele',
        'Pachete de Sunete Gratuite, Samples, Jam Tracks',
        'Acces la 2 Instrumente Legendare Simultan',
      ],
      seeMoreLabel: 'Comparați Abonamentele',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.ro.purchasable,
      features: [
        'GALAXIAS',
        'Acces anticipat la anumite produse prin Ultimate Early Access',
        'Toate Instrumentele Software și Sunetele',
      ],
      seeMoreLabel: 'Comparați Abonamentele',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  sv: [
    {
      name: FREE_LABEL.sv.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.sv.getStarted,
      features: [
        'ZENOLOGY Lite-mjukvarusynt',
        'Zenbeats MAX',
        'Möjlighet att köpa och livstidsnycklar',
        'Appar och innehåll för kompatibel Roland-hårdvara',
      ],
      seeMoreLabel: 'Mer om livstidsnycklar',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sv.purchasable,
      features: [
        'ZENOLOGY-mjukvarusynt och ljudpaket',
        'ZENOLOGY FX ',
        'SDZ och EXZ',
      ],
      seeMoreLabel: 'Jämför medlemskap',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sv.purchasable,
      features: [
        'ZENOLOGY Pro-mjukvarusynt och modellexpansioner',
        'Kostnadsfria ljudpaket, samplingar och jamspår',
        'Tillgång till två legendariska instrument åt gången',
      ],
      seeMoreLabel: 'Jämför medlemskap',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sv.purchasable,
      features: [
        'GALAXIAS',
        'Tidig tillgång till vissa produkter via Ultimate Early Access',
        'Alla mjukvaruinstrument och ljud',
      ],
      seeMoreLabel: 'Jämför medlemskap',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
  sk: [
    {
      name: FREE_LABEL.sk.label,
      monthlyPrice: '$0 / forever',
      yearlyPrice: '$0 / forever',
      ctaLabel: MEMBERSHIPS_ACTIONS.sk.getStarted,
      features: [
        'Softvérový syntetizátor ZENOLOGY Lite',
        'Zenbeats MAX',
        'Možnosť zakúpenia a doživotné licencie',
        'Sprievodné aplikácie a obsah pre kompatibilný hardvér Roland',
      ],
      seeMoreLabel: 'Ďalšie informácie do doživotných licenciách',
    },
    {
      name: 'CORE',
      monthlyPrice: '$2.99 / month',
      yearlyPrice: '$29.99 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sk.purchasable,
      features: [
        'Softvérový syntetizátor ZENOLOGY a balíky zvukov',
        'Efekty ZENOLOGY',
        'SDZ a EXZ',
      ],
      seeMoreLabel: 'Porovnať členstvá',
      monthlyPlanId: PLAN_ID.coreMonthly,
      yearlyPlanIds: [PLAN_ID.coreAnnual],
    },
    {
      name: 'PRO',
      monthlyPrice: '$9.99 / month',
      yearlyPrice: '$99.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sk.purchasable,
      features: [
        'Softvérový syntetizátor ZENOLOGY Pro a rozšírenia Model Expansion',
        'Bezplatné balíky zvukov, sample, skladby na jamovanie',
        'Prístup k 2 legendárnym nástrojom',
      ],
      seeMoreLabel: 'Porovnať členstvá',
      monthlyPlanId: PLAN_ID.proMonthly,
      yearlyPlanIds: [PLAN_ID.proAnnual, PLAN_ID.proP4L],
    },
    {
      name: 'ULTIMATE',
      monthlyPrice: '$19.99 / month',
      yearlyPrice: '$199.00 / year',
      ctaLabel: MEMBERSHIPS_ACTIONS.sk.purchasable,
      features: [
        'GALAXIAS',
        'Prednostný prístup k určitým produktom prostredníctvom služby Ultimate Early Access',
        'Všetky softvérové nástroje a zvuky',
      ],
      seeMoreLabel: 'Porovnať členstvá',
      monthlyPlanId: PLAN_ID.ultimateMonthly,
      yearlyPlanIds: [PLAN_ID.ultimateAnnual, PLAN_ID.ultimateP4L],
    },
  ],
};

export const THREE_MONTHS_INFO = {
  en: {
    title: '3-MONTHS ULTIMATE MEMBERSHIP',
    label1: 'Save $10 off Monthly Membership',
    label2: 'No Free Trial',
    planId: PLAN_ID.threeMonths,
    ctaLabel: MEMBERSHIPS_ACTIONS.en.purchasable,
  },
};

export const CONDITIONS = {
  en: {
    freeTrial: '*Free 30-day Ultimate Trial excludes certain downloadable content and is available exclusively for new users.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        and 3-Month Ultimate Memberships do not include a 30-day free trial.
      </p>
    ),
    p4lTrial: '*Play 4 Life and 3-Month Ultimate Memberships do not include a 30-day free trial.',
  },
  es: {
    freeTrial: '*La prueba gratuita de 30 días del plan Ultimate excluye cierto contenido descargable y está disponible exclusivamente para nuevos usuarios.',
    p4lTrialLink: (
      <p>
        *Las suscripciones
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        y 3-Month Ultimate no incluyen una prueba gratuita de 30 días.
      </p>
    ),
    p4lTrial: '*Las suscripciones Play 4 Life y 3-Month Ultimate no incluyen una prueba gratuita de 30 días.',
  },
  cs: {
    freeTrial: '*Bezplatná 30denní zkušební verze Ultimate nezahrnuje určitý stahovatelný obsah a je k dispozici výhradně pro nové uživatele.',
    p4lTrialLink: (
      <p>
        *Členství
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        a 3měsíční Ultimate nezahrnuje 30denní zkušební verzi zdarma.
      </p>
    ),
    p4lTrial: '*Členství Play 4 Life a 3měsíční Ultimate nezahrnuje 30denní zkušební verzi zdarma.',
  },
  de: {
    freeTrial: '*Die kostenlose 30-tägige Ultimate-Testversion schließt bestimmte herunterladbare Inhalte aus und ist ausschließlich für neue Benutzer verfügbar.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        und 3-monatige Ultimate-Mitgliedschaften beinhalten keine 30-tägige kostenlose Testphase.
      </p>
    ),
    p4lTrial: '*Play 4 Life und 3-monatige Ultimate-Mitgliedschaften beinhalten keine 30-tägige kostenlose Testphase.',
  },
  da: {
    freeTrial: '*Gratis 30-dages Ultimate Trial omfatter ikke bestemt indhold, der kan downloades, og er udelukkende tilgængelig for nye brugere.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        og 3-måneders Ultimate-medlemskaber inkluderer ikke en 30-dages gratis prøveperiode.
      </p>
    ),
    p4lTrial: '*Play 4 Life og 3-måneders Ultimate-medlemskaber inkluderer ikke en 30-dages gratis prøveperiode.',
  },
  fi: {
    freeTrial: '*Ilmaisen 30 päivän Ultimate Trial -kokeilujakson ulkopuolelle jää joitakin ladattavia sisältöjä ja se on tarjolla ainoastaan uusille käyttäjille.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        - ja 3 kuukauden Ultimate -jäsenyyksiin ei kuulu 30 päivän kokeilujaksoa.
      </p>
    ),
    p4lTrial: '*Play 4 Life - ja 3 kuukauden Ultimate -jäsenyyksiin ei kuulu 30 päivän kokeilujaksoa.',
  },
  fr: {
    freeTrial: '* L\'essai Ultimate gratuit de 30 jours exclut certains contenus téléchargeables et est réservé aux nouveaux utilisateurs.',
    p4lTrialLink: (
      <p>
        * Les abonnements
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        et Ultimate 3 mois ne comprennent pas de période d'essai gratuite de 30 jours.
      </p>
    ),
    p4lTrial: '* Les abonnements Play 4 Life et Ultimate 3 mois ne comprennent pas de période d\'essai gratuite de 30 jours.',
  },
  hu: {
    freeTrial: '*Az ingyenes 30 napos Ultimate próbaverzió kizár bizonyos letölthető tartalmakat, és kizárólag új felhasználók számára érhető el.',
    p4lTrialLink: (
      <p>
        * A
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        és a 3 hónapos Ultimate tagság nem tartalmaz 30 napos ingyenes próbaverziót.
      </p>
    ),
    p4lTrial: '*A Play 4 Life és a 3 hónapos Ultimate tagság nem tartalmaz 30 napos ingyenes próbaverziót.',
  },
  it: {
    freeTrial: '* La prova gratuita di 30 giorni della versione Ultimate non include alcuni contenuti scaricabili ed è disponibile esclusivamente per i nuovi utenti.',
    p4lTrialLink: (
      <p>
        * Gli abbonamenti
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        e 3-Month Ultimate non includono una prova gratuita di 30 giorni.
      </p>
    ),
    p4lTrial: '*Gli abbonamenti Play 4 Life e 3-Month Ultimate non includono una prova gratuita di 30 giorni.',
  },
  ja: {
    freeTrial: '*30日間の無料トライアルは新規会員限定です。また、いくつかのダウンロード可能コンテンツは含まれておりません。',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        および 3-Month Ultimate Membership には30日間の無料トライアルは含まれていません。
      </p>
    ),
    p4lTrial: '*Play 4 Life および 3-Month Ultimate Membership には30日間の無料トライアルは含まれていません。',
  },
  nl: {
    freeTrial: '*De gratis 30-dagen Ultimate Trial sluit bepaalde downloadbare content uit en is uitsluitend beschikbaar voor nieuwe gebruikers.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        en 3-Maanden Ultimate lidmaatschappen bevatten geen 30-dagen gratis proefperiode.
      </p>
    ),
    p4lTrial: '*Play 4 Life en 3-Maanden Ultimate lidmaatschappen bevatten geen 30-dagen gratis proefperiode.',
  },
  no: {
    freeTrial: '*Gratis 30-dagers prøveperiode på Ultimate ekskluderer noe nedlastbart materiale og er kun tilgjengelig for nye brukere.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        og tre måneders Ultimate-medlemskap inkluderer ikke en 30-dagers gratis prøveperiode.
      </p>
    ),
    p4lTrial: '*Play 4 Life og tre måneders Ultimate-medlemskap inkluderer ikke en 30-dagers gratis prøveperiode.',
  },
  pl: {
    freeTrial: '*Bezpłatna 30-dniowa wersja próbna Ultimate Trial nie obejmuje niektórych treści do pobrania i jest dostępna wyłącznie dla nowych użytkowników.',
    p4lTrialLink: (
      <p>
        *Członkostwa
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        i 3-miesięczne Ultimate nie obejmują 30-dniowego bezpłatnego okresu próbnego.
      </p>
    ),
    p4lTrial: '*Członkostwa Play 4 Life i 3-miesięczne Ultimate nie obejmują 30-dniowego bezpłatnego okresu próbnego.',
  },
  pt: {
    freeTrial: '*A versão gratuita de 30 dias do Ultimate Trial exclui determinados conteúdos transferíveis e está disponível exclusivamente para novos utilizadores.',
    p4lTrialLink: (
      <p>
        *As assinaturas
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        e 3-Month Ultimate não incluem um teste gratuito de 30 dias.
      </p>
    ),
    p4lTrial: '*As assinaturas Play 4 Life e 3-Month Ultimate não incluem um teste gratuito de 30 dias.',
  },
  ro: {
    freeTrial: '*Ultimate Trial gratuit de 30 de zile exclude anumite conținuturi ce se pot descărca și este disponibilă exclusiv pentru utilizatorii noi.',
    p4lTrialLink: (
      <p>
        *Abonamentele
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        și 3-Luni Ultimate nu includ o perioadă de încercare gratuită de 30 de zile.
      </p>
    ),
    p4lTrial: '*Abonamentele Play 4 Life și 3-Luni Ultimate nu includ o perioadă de încercare gratuită de 30 de zile.',
  },
  sv: {
    freeTrial: '*Den kostnadsfria 30-dagars Ultimate-provperioden omfattar inte visst nedladdningsbart innehåll och är endast tillgänglig för nya användare.',
    p4lTrialLink: (
      <p>
        *
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        och tremånaders Ultimate-medlemskap inkluderar inte en 30-dagars kostnadsfri provperiod.
      </p>
    ),
    p4lTrial: '*Play 4 Life och tremånaders Ultimate-medlemskap inkluderar inte en 30-dagars kostnadsfri provperiod.',
  },
  sk: {
    freeTrial: '* Bezplatná 30-dňová skúšobná verzia členstva Ultimate nezahŕňa určitý obsah na stiahnutie a je k dispozícii výlučne pre nových používateľov.',
    p4lTrialLink: (
      <p>
        * Členstvo
        {' '}
        <a href={process.env.REACT_APP_P4L_URL} target='_blank' rel='noreferrer'>Play 4 Life</a>
        {' '}
        a 3-mesačné členstvo Ultimate nezahŕňajú 30-dňovú bezplatnú skúšobnú verziu.
      </p>
    ),
    p4lTrial: '*Členstvo Play 4 Life a 3-mesačné členstvo Ultimate nezahŕňajú 30-dňovú bezplatnú skúšobnú verziu.',
  },
};

export const LIFETIME_KEY_INFO = {
  en: {
    title: 'What is a Lifetime Key?',
    paragraph1:
  <p>
    A Roland Cloud Lifetime Key is a
    {' '}
    <b>virtual instrument</b>
    {' '}
    and
    {' '}
    <b>software licensing</b>
    {' '}
    option. Roland Cloud is a subscription-based service that gives users access to a vast collection of Roland's classic and new synthesizers, drum machines, and other software instruments.
  </p>,
    paragraph2:
  <p>
    Lifetime Keys allow you to purchase a
    {' '}
    <b>permanent</b>
    {' '}
    license for a
    {' '}
    <b>specific</b>
    {' '}
    instrument, sound collection, or hardware add-on. In contrast to regular subscription models, Lifetime Keys are yours to keep
    {' '}
    <b>forever</b>
    {' '}
    and can be used without an active recurring subscription.
  </p>,
    paragraph3:
  <p>• A Free Roland Account and the app Roland Cloud Manager are required to access and own Lifetime Keys.</p>,
  },
  es: {
    title: '¿Qué es una Lifetime Key?',
    paragraph1:
  <p>
    Una Lifetime Key de Roland Cloud es una opción de licencia para
    {' '}
    <b>instrumentos virtuales</b>
    {' '}
    y
    {' '}
    <b>software</b>
    . Roland Cloud es un servicio por suscripción que da a los usuarios acceso a una enorme colección de sintetizadores clásicos y nuevos, cajas de ritmos y otros instrumentos de software de Roland.
  </p>,
    paragraph2:
  <p>
    Las Lifetime Keys te permiten comprar una licencia
    {' '}
    <b>permanente</b>
    {' '}
    para un instrumento, colección de sonidos o complemento de hardware específico. Al contrario que los modelos de suscripción estándar, las Lifetime Keys son tuyas para
    {' '}
    <b>siempre</b>
    {' '}
    y puedes usarlas sin una suscripción recurrente activa.
    {' '}
  </p>,
    paragraph3:
  <p>• Para acceder a Lifetime Keys y poseerlas necesitas una Roland Account gratuita y la app Roland Cloud Manager.</p>,
  },
  cs: {
    title: 'Co je to licence Lifetime Key?',
    paragraph1:
  <p>
    Doživotní klíč Roland Cloud je možnost
    {' '}
    <b>licencování virtuálního nástroje</b>
    {' '}
    a
    {' '}
    <b>softwaru</b>
    . Roland Cloud je služba založená na předplatném, která uživatelům poskytuje přístup k rozsáhlé sbírce klasických i nových syntezátorů, bicích automatů a dalších softwarových nástrojů Roland.
  </p>,
    paragraph2:
  <p>
    Doživotní klíče umožňují zakoupit
    {' '}
    <b>trvalou licenci</b>
    {' '}
    pro
    {' '}
    <b>konkrétní</b>
    {' '}
    nástroj, kolekci zvuků nebo hardwarový doplněk. Na rozdíl od běžných modelů předplatného si licenci Lifetime Keys můžete ponechat
    {' '}
    <b>navždy</b>
    {' '}
    a používat je bez aktivního opakovaného předplatného.
  </p>,
    paragraph3:
  <p>• Pro přístup k doživotním klíčům a jejich vlastnictví je vyžadován bezplatný účet Roland a aplikace Roland Cloud Manager.</p>,
  },
  de: {
    title: 'Was ist ein Lifetime Key?',
    paragraph1:
  <p>
    Ein Roland Cloud Lifetime Key ist eine
    {' '}
    <b>Software-Lizenzoption</b>
    {' '}
    für ein
    {' '}
    <b>virtuelles Instrument</b>
    . Roland Cloud ist ein Abonnement-Service, mit dem Anwender Zugang zu einer riesigen Auswahl an klassischen und neuen Roland Synthesizern, Drum Machines und weiteren Software-Instrumenten haben.
  </p>,
    paragraph2:
  <p>
    Mit einem Lifetime Key erwirbst du eine
    {' '}
    <b>dauerhafte Lizenz</b>
    {' '}
    für ein
    {' '}
    <b>bestimmtes</b>
    {' '}
    Instrument, eine Sound-Kollektion oder ein Hardware-Add-on. Im Gegensatz zu den Abo-Modellen sind Lifetime Keys
    {' '}
    <b>zeitlich unbegrenzt</b>
    {' '}
    und können auch ohne ein aktives Abonnement genutzt werden.
  </p>,
    paragraph3:
  <p>• Zur Nutzung eines Lifetime Keys ist ein kostenloser Roland Account und die Roland Cloud Manager App erforderlich.</p>,
  },
  da: {
    title: 'Hvad er en Lifetime Key?',
    paragraph1:
  <p>
    En Roland Cloud Lifetime Key er en
    {' '}
    <b>licensmulighed</b>
    {' '}
    for
    {' '}
    <b>virtuelle instrumenter</b>
    {' '}
    og
    {' '}
    <b>software</b>
    . Roland Cloud er en abonnementsbaseret tjeneste, der giver brugerne adgang til en stor samling af Rolands klassiske og nye synthesizere, trommemaskiner og andre softwareinstrumenter.
  </p>,
    paragraph2:
  <p>
    Lifetime Keys giver dig mulighed for at købe en
    {' '}
    <b>permanent licens</b>
    {' '}
    til et
    {' '}
    <b>bestemt</b>
    {' '}
    instrument, en lydsamling eller et hardware add-on. I modsætning til almindelige abonnementsmodeller er Lifetime Keys dine
    {' '}
    <b>for evigt</b>
    {' '}
    og kan bruges uden et aktivt, tilbagevendende abonnement.
  </p>,
    paragraph3:
  <p>• En gratis Roland-konto og appen Roland Cloud Manager er påkrævet for at få adgang til og eje Lifetime Keys.</p>,
  },
  fi: {
    title: 'Mikä on Lifetime Key?',
    paragraph1:
  <p>
    Roland Cloud Lifetime Key
    {' '}
    <b>virtuaalisten instrumenttien</b>
    {' '}
    ja
    {' '}
    <b>ohjelmistojen lisensointivaihtoehto</b>
    . Roland Cloud on tilauspohjainen palvelu, joka tarjoaa käyttäjille pääsyn Rolandin valtavaan klassisten ja uusien syntikoiden, rumpukoneiden ja muiden softa-instrumenttien valikoimaan.
  </p>,
    paragraph2:
  <p>
    Lifetime Key -vaihtoehdolla saat lunastettua halutun instrumentin, soundikokoelman, tai hardwaren lisäosan
    {' '}
    <b>kiinteän lisenssin</b>
    . Normaaleihin tilausmalleihin verrattuna Lifetime Key -lisenssit ovat sinun
    {' '}
    <b>ikuisesti</b>
    {' '}
    ja niitä voidaan käyttää ilman aktiivista uusiutuvaa tilausta.
  </p>,
    paragraph3:
  <p>• Ilmainen Roland-tili ja Roland Cloud Manager -sovellus ovat edellytyksiä Lifetime Key -lisenssien hankintaan ja omistukseen.</p>,
  },
  fr: {
    title: "Qu'est-ce qu'une Lifetime Key ?",
    paragraph1:
  <p>
    Une Lifetime Key Roland Cloud est une option de
    {' '}
    <b>licence logicielle</b>
    {' '}
    pour un
    {' '}
    <b>instrument virtuel</b>
    . Roland Cloud est un service proposé par abonnement qui donne à ses utilisateurs l'accès à une vaste collection de synthétiseurs, boîtes à rythmes et autres instruments logiciels, classiques ou récents.
  </p>,
    paragraph2:
  <p>
    Les Lifetime Keys vous permettent d'acheter une licence
    {' '}
    <b>permanente</b>
    {' '}
    pour un instrument
    {' '}
    <b>spécifique</b>
    , une collection de sons ou un complément matériel. Contrairement aux abonnements classiques, les Lifetime Keys sont à vous
    {' '}
    <b>pour toujours</b>
    {' '}
    et peuvent être utilisées sans abonnement récurrent actif.
  </p>,
    paragraph3:
  <p>• Un compte Roland gratuit et l'application Roland Cloud Manager sont nécessaires pour accéder aux Lifetime Keys et en être propriétaire.</p>,
  },
  hu: {
    title: 'Mi a Lifetime Key?',
    paragraph1:
  <p>
    A Roland Cloud Lifetime Key egy
    {' '}
    <b>virtuális hangszer</b>
    {' '}
    és
    {' '}
    <b>szoftver licenc</b>
    {' '}
    lehetőség. A Roland Cloud egy előfizetéses szolgáltatás, amely hozzáférést biztosít a felhasználóknak a Roland klasszikus és új szintetizátorainak, dobgépeinek és egyéb szoftveres hangszereinek hatalmas gyűjteményéhez.
  </p>,
    paragraph2:
  <p>
    A Lifetime Key opciók lehetővé teszik, hogy
    {' '}
    <b>örök licencet</b>
    {' '}
    vásárolj egy
    {' '}
    <b>adott hangszerhez</b>
    , hanggyűjteményhez vagy hardverbővítményhez. A hagyományos előfizetéses modellekkel ellentétben a Lifetime Key
    {' '}
    <b>örökre</b>
    {' '}
    megtartható, és ismétlődő aktív előfizetés nélkül is használható.
  </p>,
    paragraph3:
  <p>• Ingyenes Roland fiók és a Roland Cloud Manager alkalmazás szükséges a Lifetime Key opciók eléréséhez és birtoklásához.</p>,
  },
  it: {
    title: 'Che cos\'è una Lifetime Key?',
    paragraph1:
  <p>
    Una Lifetime Key Roland Cloud è un'opzione per ottenere la licenza di un
    {' '}
    <b>virtual instrument</b>
    {' '}
    o di un
    {' '}
    <b>software</b>
    . Roland Cloud è un servizio in abbonamento che offre agli utenti l'accesso a una vasta collezione di sintetizzatori, drum machine e altri strumenti software Roland, classici e nuovi.
  </p>,
    paragraph2:
  <p>
    Le Lifetime Key vi permettono di acquistare una
    {' '}
    <b>licenza permanente</b>
    {' '}
    per uno
    {' '}
    <b>strumento</b>
    , una collezione di suoni o add-on hardware specifici. Diversamente dai modelli di abbonamento standard, le Lifetime Key sono vostre
    {' '}
    <b>per sempre</b>
    {' '}
    e possono essere usate senza un abbonamento periodico attivo.
  </p>,
    paragraph3:
  <p>• Sono necessari un Account Roland gratuito e l'applicazione Roland Cloud Manager per accedere ed entrare in possesso delle Lifetime Key.</p>,
  },
  ja: {
    title: 'Lifetime Key とは？',
    paragraph1:
  <p>
    Roland Cloud Lifetime Key は、
    <b>バーチャル・インストゥルメント</b>
    および
    <b>ソフトウェア・ライセンス</b>
    のオプションです。Roland Cloud は、Roland のクラシックおよび最新のシンセサイザー、ドラムマシン、その他のソフトウェア・インストゥルメントの膨大なコレクションにアクセスできるサブスクリプション・ベースのサービスです。
  </p>,
    paragraph2:
  <p>
    Lifetime Key では、
    <b>特定の</b>
    インストゥルメント、サウンド・コレクション、またはハードウェア追加機能の
    <b>永久</b>
    ライセンスを購入できます。通常のサブスクリプション・モデルとは異なり、Lifetime Key は
    <b>永久に</b>
    保持でき、定期サブスクリプションに加入しなくても使用できます。
  </p>,
    paragraph3:
  <p>• Lifetime Key へのアクセスと所有には、無料の Rolandアカウントとアプリ Roland Cloud Manager が必要です。</p>,
  },
  nl: {
    title: 'Wat is een Lifetime Key?',
    paragraph1:
  <p>
    Een Roland Cloud Lifetime Key is een
    {' '}
    <b>virtueel instrument</b>
    {' '}
    en een optie voor
    {' '}
    <b>softwarelicentie</b>
    . Roland Cloud is een dienst op abonnementsbasis die gebruikers toegang geeft tot een uitgebreide Roland-collectie klassieke en nieuwe synthesizers, drummachines en andere software-instrumenten.
  </p>,
    paragraph2:
  <p>
    Met Lifetime Keys kun je een
    {' '}
    <b>permanente</b>
    {' '}
    licentie kopen voor een
    {' '}
    <b>specifiek</b>
    {' '}
    instrument, een soundcollectie of een hardware-uitbreiding. In tegenstelling tot reguliere abonnementsmodellen kun je Lifetime Keys
    {' '}
    <b>voor altijd</b>
    {' '}
    houden en gebruiken zonder een actief terugkerend abonnement.
  </p>,
    paragraph3:
  <p>• Een gratis Roland Account en de app Roland Cloud Manager zijn nodig om toegang te krijgen tot Lifetime Keys en deze te bezitten.</p>,
  },
  no: {
    title: 'Hva er en Lifetime Key?',
    paragraph1:
  <p>
    En Roland Cloud Lifetime Key er et
    {' '}
    <b>virtuelt instrument</b>
    {' '}
    og en
    {' '}
    <b>programvarelisens</b>
    . Roland Cloud er en abonnementsbasert tjeneste som gir brukerne adgang til et stort utvalg av Rolands klassiske og nye synthesizere, trommemaskiner og andre programvareinstrumenter.
  </p>,
    paragraph2:
  <p>
    Lifetime Keys lar deg kjøpe en
    {' '}
    <b>permanent</b>
    {' '}
    lisens til et
    {' '}
    <b>spesifikt</b>
    {' '}
    instrument, en lydsamling eller et hardwaretillegg. Til forskjell fra vanlige abonnementsmodeller, er Lifetime Keys dine
    {' '}
    <b>for alltid</b>
    , og kan brukes uten et aktivt abonnement.
  </p>,
    paragraph3:
  <p>• En gratis Roland-brukerkonto og appen Roland Cloud Manager kreves for å få tilgang til og å eie Lifetime Keys.</p>,
  },
  pl: {
    title: 'Czym jest Lifetime Key?',
    paragraph1:
  <p>
    Roland Cloud Lifetime Key to
    {' '}
    <b>wirtualny instrument</b>
    {' '}
    i
    {' '}
    <b>licencjonowanie oprogramowania</b>
    . Roland Cloud to usługa oparta na subskrypcji, która zapewnia użytkownikom dostęp do bogatej kolekcji klasycznych i nowych syntezatorów, automatów perkusyjnych i innych instrumentów programowych firmy Roland.
  </p>,
    paragraph2:
  <p>
    Lifetime Keys umożliwiają zakup
    {' '}
    <b>stałej</b>
    {' '}
    licencji na
    {' '}
    <b>określony</b>
    {' '}
    instrument, kolekcję dźwięków lub dodatek sprzętowy. W przeciwieństwie do standardowych modeli subskrypcji, klucze Lifetime Keys są dostępne
    {' '}
    <b>na zawsze</b>
    {' '}
    i można z nich korzystać bez konieczności wykupywania aktywnej odnawialnej subskrypcji.
  </p>,
    paragraph3:
  <p>• Darmowe Konto Roland i aplikacja Roland Cloud Manager są wymagane do uzyskania dostępu i posiadania Lifetime Keys.</p>,
  },
  pt: {
    title: 'O que é uma Chave Vitalícia?',
    paragraph1:
  <p>
    Uma Roland Cloud Lifetime Key é um
    {' '}
    <b>instrumento virtual</b>
    {' '}
    e uma opção de
    {' '}
    <b>licenciamento de software</b>
    . A Roland Cloud é um serviço baseado em subscrição que dá aos utilizadores acesso a uma vasta coleção de sintetizadores clássicos e novos da Roland, drum machines e outros instrumentos de software.
  </p>,
    paragraph2:
  <p>
    As chaves vitalícias permitem adquirir uma
    {' '}
    <b>licença permanente</b>
    {' '}
    para um
    {' '}
    <b>instrumento específico</b>
    , coleção de sons ou complemento de hardware. Em contraste com os modelos de subscrição regulares, as Chaves Vitalícias são tuas para
    {' '}
    <b>sempre</b>
    {' '}
    e podem ser utilizadas sem uma subscrição recorrente ativa.
  </p>,
    paragraph3:
  <p>• É necessária uma conta Roland gratuita e a aplicação Roland Cloud Manager para aceder e possuir Lifetime Keys.</p>,
  },
  ro: {
    title: 'Ce este Lifetime Key?',
    paragraph1:
  <p>
    Lifetime Key Roland Cloud este un
    {' '}
    <b>instrument virtual</b>
    {' '}
    și o opțiune de
    {' '}
    <b>licențiere software</b>
    . Roland Cloud este un serviciu pe bază de abonament care oferă utilizatorilor acces la o colecție vastă de sintetizatoare clasice și noi, tobe și alte instrumente software Roland.
  </p>,
    paragraph2:
  <p>
    Lifetime Keys vă permite să achiziționați o
    {' '}
    <b>licență permanentă</b>
    {' '}
    pentru un
    {' '}
    <b>instrument specific</b>
    , colecție de sunet sau supliment hardware. Spre deosebire de modelele obișnuite de abonament, Lifetime Keys sunt ale dvs.
    {' '}
    <b>pentru totdeauna</b>
    {' '}
    și pot fi folosite fără un abonament recurent activ.
  </p>,
    paragraph3:
  <p>• Un cont Roland gratuit și aplicația Roland Cloud Manager sunt necesare pentru a accesa și a deține Lifetime Keys.</p>,
  },
  sv: {
    title: 'Vad är en livstidsnyckel?',
    paragraph1:
  <p>
    En livstidsnyckel på Roland Cloud är ett
    {' '}
    <b>virtuellt instrument</b>
    {' '}
    och ett
    {' '}
    <b>mjukvarulicens</b>
    -alternativ. Roland Cloud är en prenumerationsbaserad tjänst som ger användarna tillgång till en stor samling av Rolands klassiska och nya synthesizers, trummaskiner och andra mjukvaruinstrument.
  </p>,
    paragraph2:
  <p>
    Med livstidsnycklar kan du köpa en
    {' '}
    <b>permanent</b>
    {' '}
    licens för ett
    {' '}
    <b>specifikt</b>
    {' '}
    instrument, viss ljudsamling eller ett hårdvarutillägg. I motsats till vanliga prenumerationsmodeller är livstidsnycklar dina
    {' '}
    <b>för alltid</b>
    {' '}
    och kan användas utan en aktiv återkommande prenumeration.
  </p>,
    paragraph3:
  <p>• Ett kostnadsfritt Roland-konto och appen Roland Cloud Manager krävs för att få tillgång till och äga livstidsnycklar.</p>,
  },
  sk: {
    title: 'Čo je doživotná licencia?',
    paragraph1:
  <p>
    Doživotná licencia Roland Cloud je
    {' '}
    <b>virtuálny nástroj</b>
    {' '}
    a možnosť
    {' '}
    <b>licencovania softvéru</b>
    . Roland Cloud je služba na báze predplatného, ktorá používateľom poskytuje prístup k rozsiahlej kolekcii klasických a nových syntetizátorov, bicích automatov a ďalších softvérových nástrojov Roland.
  </p>,
    paragraph2:
  <p>
    Doživotné licencie vám umožňujú zakúpiť si
    {' '}
    <b>trvalú</b>
    {' '}
    licenciu na
    {' '}
    <b>konkrétny</b>
    {' '}
    nástroj, kolekciu zvukov alebo hardvérový doplnok. Na rozdiel od bežných modelov predplatného vám doživotné licencie patria
    {' '}
    <b>navždy</b>
    {' '}
    a môžete ich používať bez aktívneho pravidelného predplatného.
  </p>,
    paragraph3:
  <p>• Na prístup k doživotným licenciám a ich vlastníctvo je potrebný bezplatný účet Roland a aplikácia Roland Cloud Manager.</p>,
  },
};

export const MEMBERSHIP_INFO = {
  en: {
    title: 'Compare Memberships Plans',
    disclaimers: [
      '*: Activate Two Legendary Instruments with Pro Access Selector',
      '**: Sound Packs, Wave Expansions, and Model Expansions included within membership for use exclusively in ZENOLOGY. To use Sound Packs, Wave Expansions, and Model Expansions with compatible hardware, please purchase the corresponding Lifetime Key.',
      'Please refer to the "End User License Agreement and Terms of Service" to see our Membership policies. Pricing is listed in USD$ and does not include applicable taxes. Pricing at checkout will be in local currency with applicable taxes applied.',
    ],
    note_02: 'Please refer to the "End User License Agreement and Terms of Service" to see our Membership policies. Pricing is listed in USD$ and does not include applicable taxes. Pricing at checkout will be in local currency with applicable taxes applied.',
  },
  es: {
    title: 'Compara los planes de suscripción',
    disclaimers: [
      '*: Activa dos instrumentos Legendary con el Pro Access Selector',
      '**: Los Sound Packs, Wave Expansions y Model Expansions incluidos en la suscripción solo se pueden usar en ZENOLOGY. Para usarlos con hardware compatible, se debe comprar la Lifetime Key correspondiente.',
      'Consulta el "Acuerdo de licencia de usuario final y condiciones del servicio" para conocer nuestras políticas de suscripción. Los precios están en USD$ y no incluyen impuestos aplicables. El precio final se mostrará en tu moneda local con los impuestos correspondientes.',
    ],
    note_02: 'Consulta el "Acuerdo de licencia de usuario final y condiciones del servicio" para conocer nuestras políticas de suscripción. Los precios están en USD$ y no incluyen impuestos aplicables. El precio final se mostrará en tu moneda local con los impuestos correspondientes.',
  },
  ja: {
    title: 'メンバーシップ・プランの比較',
    disclaimers: [
      '*: Legendary シリーズのインストゥルメントからお好きなもの２つを選択可能',
      '**: メンバーシップに含まれる Sound Pack、Wave Expansion、および Model Expansion は、ZENOLOGY でのみご利用いただけます。 互換性のあるハードウェア製品でこれらをご利用になる場合は、対応する Lifetime Key をご購入ください。',
      'メンバーシップ・ポリシーについては、「エンドユーザーライセンス契約および利用規約」をご覧ください。 価格は USD$（米ドル）にて記載されており、該当する税金は含まれていません。決済される価格は、税金が適用された現地通貨で表示されます。',
    ],
    note_02: 'メンバーシップ・ポリシーについては、「エンドユーザーライセンス契約および利用規約」をご覧ください。価格は USD$ (米ドル)にて記載されており、該当する税金は含まれていません。決済される価格は、税金が適用された現地通貨で表示されます。',
  },
  cs: {
    note_02: 'Naše zásady a pravidla členství najdete v „Licenčním ujednání koncového uživatele a Podmínkách použití“. Cena je uvedena v USD a nezahrnuje příslušné daně. Cena při placení bude v místní měně s uplatněním příslušných daní.',
  },
  de: {
    note_02: 'Naše zásady a pravidla členství najdete v „Licenčním ujednání koncového uživatele a Podmínkách použití“. Cena je uvedena v USD a nezahrnuje příslušné daně. Cena při placení bude v místní měně s uplatněním příslušných daní.',
  },
  fi: {
    note_02: 'Tutustu "Loppukäyttäjän lisenssisopimus ja palvelun ehdot" -tiedostoon, josta löydät lisätietoa jäsenyyden menettelytavoista. Hinnoittelu on ilmoitettu USD: ssä, eikä se sisällä sovellettavia veroja. Hinnoittelu kassalla tapahtuu paikallisessa valuutassa sovellettavien verojen kanssa.',
  },
  fr: {
    note_02: 'Merci de vous référer à "Accord de licence utilisateur final et conditions du service" pour connaître notre politique en matière de d\'abonnements. Les prix sont indiqués en USD$ et n\'incluent pas les taxes applicables. Les prix à la caisse seront en devise locale avec les taxes applicables appliquées.',
  },
  hu: {
    note_02: 'Kérjük, olvasd el a Végfelhasználói Licencszerződést és a Felhasználási Feltételeket valamint tekintsd meg a Tagságra vonatkozó irányelveinket. Az árak USD dollárban vannak feltüntetve, és nem tartalmazzák az alkalmazandó adókat. Az árak a fizetéskor helyi pénznemben lesznek érvényben, az alkalmazott adókkal együtt.',
  },
  it: {
    note_02: 'Fai riferimento all"Accordo di Licenza per l\'Utente Finale e Termini del Servizio" per conoscere le nostre policy relative all\'Abbonamento. I prezzi sono elencati in USD$ e non includono le tasse applicabili. I prezzi al momento del pagamento saranno nella valuta locale con le tasse applicabili applicate.',
  },
  no: {
    note_02: 'Se "Lisensavtale og servicevilkår for sluttbruker" for å se retningslinjene våre. Priser er oppført i USD$ og inkluderer ikke gjeldende avgifter. Priser ved kassen vil være i lokal valuta med gjeldende avgifter pålagt.',
  },
  pl: {
    note_02: 'Zapoznaj się z „Umową Licencyjną Użytkownika Końcowego i Warunkami Korzystania z Usługi” aby zapoznać się z naszymi zasadami Członkostwa. Ceny są podane w USD i nie obejmują obowiązujących podatków. Ceny przy kasie zostaną podane w lokalnej walucie z obowiązującymi podatkami.',
  },
  pr: {
    note_02: 'Por favor, consulta o "Contrato de Licença e os Termos de Serviço do Consumidor Final" para obter todas as informações sobre as nossas Políticas de Subscrição. O preço está listado em USD $ e não inclui impostos aplicáveis. O preço na finalização da compra será em moeda local com impostos aplicáveis.',
  },
  ro: {
    note_02: 'Te rugăm să consulți „Contractul De Licență Pentru Utilizatorul Final Și Termenii De Servicii” pentru a vedea politica noastră privind Abonamentele. Prețul este listat în USD USD și nu include taxele aplicabile. Prețurile la checkout vor fi în moneda locală, cu taxele aplicabile aplicate.',
  },
  sk: {
    note_02: 'Pravidlá týkajúce sa členstiev nájdete v dokumente Licenčná zmluva s koncovým používateľom a podmienky poskytovania služby. Cena je uvedená v USD a nezahŕňa príslušné dane. Cena pri platbe bude v miestnej mene s uplatnenými príslušnými daňami.',
  },
  sv: {
    note_02: 'Se licensavtalet för slutanvändare och användarvillkoren för att läsa om våra policyer för medlemskap. Priserna anges i USD $ och inkluderar inte tillämpliga skatter. Priserna vid utcheckningen sker i lokal valuta med tillämpliga skatter.',
  },
};

export const HEADER_INFO = {
  en: {
    header: 'Select your Roland Cloud Membership',
    subheader:
  <>
    <b>30-day free trial*</b>
  </>,
  },
  es: {
    header: 'Selecciona tu suscripción a Roland Cloud',
    subheader:
  <>
    <b>30 días de prueba gratis*</b>
  </>,
  },
  cs: {
    header: 'Zvolte si své členství v Roland Cloud',
    subheader:
  <>
    <b>30denní zkušební verze zdarma*</b>
  </>,
  },
  de: {
    header: 'Wähle deine Roland Cloud Mitgliedschaft',
    subheader:
  <>
    <b>Kostenlose 30-tägige Testphase*</b>
  </>,
  },
  da: {
    header: 'Vælg dit Roland Cloud-medlemskab ',
    subheader:
  <>
    <b>30 dages gratis prøveperiode*.</b>
  </>,
  },
  fi: {
    header: 'Valitse Roland Cloud -jäsenyytesi ',
    subheader:
  <>
    <b>30 päivän ilmainen kokeilujakso*.</b>
  </>,
  },
  fr: {
    header: 'Choisissez votre abonnement Roland Cloud',
    subheader:
  <>
    <b>Essai gratuit de 30 jours*</b>
  </>,
  },
  hu: {
    header: 'Válaszd ki a Roland Cloud tagságodat',
    subheader:
  <>
    <b>30 napig ingyenes*</b>
  </>,
  },
  it: {
    header: 'Seleziona il tuo abbonamento a Roland Cloud',
    subheader:
  <>
    <b>Prova gratuita di 30 giorni *</b>
  </>,
  },
  ja: {
    header: 'ご希望の Roland Cloud メンバーシップを選択してください',
    subheader:
  <>
    <b>30日間 無料トライアル*</b>
  </>,
  },
  nl: {
    header: 'Selecteer je Roland Cloud Lidmaatschap',
    subheader:
  <>
    <b>30 dagen gratis proefperiode*</b>
  </>,
  },
  no: {
    header: 'Velg Roland Cloud medlemskap',
    subheader:
  <>
    <b>30 dagers prøveperiode*</b>
  </>,
  },
  pl: {
    header: 'Wybierz Członkostwo w Roland Cloud',
    subheader:
  <>
    <b>30-dniowy bezpłatny okres próbny*</b>
  </>,
  },
  pt: {
    header: 'Seleciona a tua adesão à Roland Cloud',
    subheader:
  <>
    <b>30 dias de teste gratuito*</b>
  </>,
  },
  ro: {
    header: 'Selectați Abonamentul dvs. Roland Cloud',
    subheader:
  <>
    <b>Test gratuit de 30 de zile*</b>
  </>,
  },
  sv: {
    header: 'Välj ditt Roland Cloud-medlemskap',
    subheader:
  <>
    <b>30-dagars kostnadsfri provperiod*</b>
  </>,
  },
  sk: {
    header: 'Vyberte si členstvo v službe Roland Cloud',
    subheader:
  <>
    <b>Bezplatná 30-dňová skúšobná verzia*</b>
  </>,
  },
};

export const TABS = {
  en: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  es: {
    monthly: 'Mensual',
    yearly: 'Anual (ahorra hasta un 17%)',
  },
  cs: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  de: {
    monthly: 'Monatlich',
    yearly: 'Jährlich (spare bis zu 17%)',
  },
  da: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  fi: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  fr: {
    monthly: 'Mensuel',
    yearly: 'Annuel (économisez jusqu\'à 17 %)',
  },
  hu: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  it: {
    monthly: 'Mensile',
    yearly: 'Annuale (risparmia sino al 17%)',
  },
  ja: {
    monthly: '月間',
    yearly: '年間 - 最大 17% お得',
  },
  nl: {
    monthly: 'Maandelijks',
    yearly: 'Jaarlijks (bespaar tot 17%)',
  },
  no: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  pl: {
    monthly: 'Miesięczny',
    yearly: 'Roczne (zaoszczędź do 17%)',
  },
  pt: {
    monthly: 'Mensal',
    yearly: 'Anual (poupa até 17%)',
  },
  ro: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  sv: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
  sk: {
    monthly: 'Monthly',
    yearly: 'Annually (save up to 17%)',
  },
};

export const POPULAR_TAG = {
  en: {
    label: 'MOST POPULAR',
  },
  es: {
    label: 'LA MÁS POPULAR',
  },
  cs: {
    label: 'NEJOBLÍBENĚJŠÍ',
  },
  de: {
    label: 'AM BELIEBTESTEN',
  },
  da: {
    label: 'MEST POPULÆRE',
  },
  fi: {
    label: 'SUOSITUIN',
  },
  fr: {
    label: 'LE PLUS POPULAIRE',
  },
  hu: {
    label: 'LEGNÉPSZERŰBB',
  },
  it: {
    label: 'I PIÙ POPOLARI',
  },
  ja: {
    label: '１番人気',
  },
  nl: {
    label: 'MEEST POPULAIR',
  },
  no: {
    label: 'MEST POPULÆR',
  },
  pl: {
    label: 'NAJBARDZIEJ POPULARNE',
  },
  pt: {
    label: 'MAIS POPULAR',
  },
  ro: {
    label: 'CEL MAI POPULAR',
  },
  sv: {
    label: 'POPULÄRAST',
  },
  sk: {
    label: 'NAJOBĽÚBENEJŠIE',
  },
};

export const REQUIRED_ACCOUNT = {
  en: {
    label:
  <>
    Access to Roland Cloud requires a
    <b> Roland Account</b>
    . Get started by selecting your preferred membership tier.
  </>,
  },
  es: {
    label:
  <>
    El acceso a Roland Cloud requiere una
    <b> Roland Account</b>
    . Para empezar, selecciona el nivel de suscripción deseado.
  </>,
  },
  cs: {
    label:
  <>
    Přístup ke službě Roland Cloud vyžaduje
    <b> účet Roland</b>
    . Začněte výběrem preferované úrovně členství.
  </>,
  },
  de: {
    label:
  <>
    Für den Zugang zur Roland Cloud wird ein
    <b> Roland Account </b>
    {' '}
    benötigt. Wähle deine gewünschte Mitgliedschaft und lege los.
  </>,
  },
  da: {
    label:
  <>
    Adgang til Roland Cloud kræver en
    <b> Roland Account</b>
    . Kom i gang ved at vælge dit foretrukne medlemsniveau.
  </>,
  },
  fi: {
    label:
  <>
    Roland Cloud:iin pääsy edellyttää
    <b> Roland-tiliä</b>
    . Aloita valitsemalla haluamasi jäsenyystaso.
  </>,
  },
  fr: {
    label:
  <>
    L'accès à Roland Cloud nécessite d'ouvrir un
    <b> Compte Roland</b>
    . Lancez-vous en choisissant votre option d'abonnement.
  </>,
  },
  hu: {
    label:
  <>
    A Roland Cloud eléréséhez
    <b> Roland fiók szükséges</b>
    . Kezdj hozzá a kívánt tagsági szint kiválasztásával.
  </>,
  },
  it: {
    label:
  <>
    L'accesso a Roland Cloud richiede un
    <b> Account Roland</b>
    . Iniziate selezionando il vostro livello di abbonamento preferito.
  </>,
  },
  ja: {
    label:
  <>
    Roland Cloud へのアクセスには
    <b> Rolandアカウント</b>
    が必要です。 ご希望のメンバーシップ・プランを選択して始めましょう。
  </>,
  },
  nl: {
    label:
  <>
    Toegang tot Roland Cloud vereist een
    <b> Roland Account</b>
    . Begin door het gewenste lidmaatschapsniveau te kiezen.
  </>,
  },
  no: {
    label:
  <>
    Adgang til Roland Cloud krever en
    <b> Roland-brukerkonto</b>
    . Kom i gang ved å velge det abonnementet du ønsker.
  </>,
  },
  pl: {
    label:
  <>
    Dostęp do Roland Cloud wymaga
    <b> Konta Roland</b>
    . Zacznij od wybrania preferowanego poziomu członkostwa.
  </>,
  },
  pt: {
    label:
  <>
    O acesso à Roland Cloud requer um espaço de uma
    <b> Roland Account</b>
    . Começa por selecionar o teu nível de adesão preferido.
  </>,
  },
  ro: {
    label:
  <>
    Accesul la Roland Cloud necesită un
    <b> Cont Roland</b>
    . Începeți prin a selecta nivelul de membru preferat.
  </>,
  },
  sv: {
    label:
  <>
    För åtkomst till Roland Cloud krävs ett
    <b> Roland-konto</b>
    . Kom igång genom att välja önskad medlemsnivå.
  </>,
  },
  sk: {
    label:
  <>
    Na prístup k službe Roland Cloud je potrebný
    <b> účet Roland</b>
    . Začnite výberom preferovanej úrovne členstva.
  </>,
  },
};

export const THANK_YOU_INFO = {
  en: {
    header: 'Thank you for your subscription!',
    subscriptionActive: 'Subscription active',
    nowActive: 'Now active',
    subtitle1: 'Your xxx plan is now active.',
    subtitle2:
  <p>
    You can check all details on your
    {' '}
    <a href={`${window.location.origin}${process.env.REACT_APP_DETAILS_REDIRECT}`}>Account page</a>
    .
  </p>,
    subscriptionDetails: 'Subscription details',
    membershipLabel: 'membership',
    subtotal: 'Subtotal',
    total: 'Total',
    download: 'Get started now by downloading Roland Cloud Manager.',
    downloadBtn: 'Get Roland Cloud Manager',
    windows: 'For Windows',
    mac: 'For macOS 15 and above',
    macLegacy: 'For macOS Legacy (12, 13 and 14)',
  },
  ja: {
    header: 'サブスクリプションへのご加入ありがとうございます！',
    subscriptionActive: 'サブスクリプション有効',
    nowActive: '有効中',
    subtitle1: 'xxx プランが有効になりました。',
    subtitle2:
  <p>
    すべての詳細は
    <a href={`${window.location.origin}${process.env.REACT_APP_DETAILS_REDIRECT}`}>
      アカウント・ページ
    </a>
    で確認できます。
  </p>,
    orderDetails: '注文詳細',
    membershipLabel: 'メンバーシップ',
    subtotal: '小計',
    total: '合計',
    download: 'Roland Cloud Manager をダウンロードして今すぐ始めましょう',
    downloadBtn: 'Roland Cloud Manager を入手',
    windows: 'Windows 版',
    mac: 'macOS 14 以上版',
    macLegacy: 'macOS Legacy（11、12、および 13）版',
  },
};

const PRD_URL = 'https://www.roland.com';
export const ACTIVE_OFFERS_SKUS = window.location.origin.includes(PRD_URL)
  || process.env.REACT_APP_HOME?.includes(PRD_URL)
  ? ['98375489', '98723423']
  : ['XUWZ4283', 'IUYW8734'];

export const TABLES = {
  en: [
    {
      title: 'GALAXIAS',
      data: [
        {
          instrument: 'GALAXIAS',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: null,
        },
      ],
    },
    {
      title: 'ZENOLOGY',
      data: [
        {
          instrument: 'ZENOLOGY',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: 'ZENOLOGY FX',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: 'ZENOLOGY PRO',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$229.00',
        },
        {
          instrument: 'Model Expansions **',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00 Each',
        },
        {
          instrument: 'Sound Packs ** (Model Expansions)',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$19.99 Each',
        },
        {
          instrument: 'Sound Packs ** (SDZ001-100)',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: '$4.99 Each',
        },
        {
          instrument: 'Sound Packs ** (SDZ101-)',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: '$9.99 Each',
        },
        {
          instrument: 'Sound Pack ** (ZEZ001-)',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: '$9.99 Each',
        },
        {
          instrument: 'Wave Expansions ** (EXZ)',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: '$19.99 Each',
        },
      ],
    },
    {
      title: 'Virtual Instruments',
      data: [
        {
          instrument: 'EARTH Piano',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$249.00',
        },
        {
          instrument: 'JD-800',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'D-50',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'TR-808',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'TR-909',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'TR-707',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'TR-727',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'TR-606',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'JUNO-60',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'JUNO-106',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'JUPITER-8',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'JUPITER-4',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'JX-3P',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'TB-303',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$149.00',
        },
        {
          instrument: 'JV-1080',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$129.00',
        },
        {
          instrument: 'XV-5080',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$129.00',
        },
        {
          instrument: 'System-8',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$129.00',
        },
        {
          instrument: 'System-1',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$99.00',
        },
        {
          instrument: 'Promars',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$99.00',
        },
        {
          instrument: 'SH-101',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$99.00',
        },
        {
          instrument: 'SH-2',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$99.00',
        },
        {
          instrument: 'System-100',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$129.00',
        },
        {
          instrument: 'SRX Collection: 10 titles',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$69.00 Each',
        },
        {
          instrument: 'DW Soundworks',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$199.00',
        },
      ],
    },
    {
      title: 'Software Effects',
      data: [
        {
          instrument: 'JUNO-60 Chorus',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$99.00',
        },
        {
          instrument: 'RE-201 Space Echo',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'JC-120 Jazz Chorus',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '$199.00',
        },
        {
          instrument: 'BOSS Effects Pedals',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: '-',
        },
      ],
    },
    {
      title: 'Patches & Patterns',
      data: [
        {
          instrument: 'Patches & Patterns',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$19.99 Each',
        },
      ],
    },
    {
      title: 'Jam Tracks',
      data: [
        {
          instrument: 'Jam Tracks',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$14.99 Each',
        },
      ],
    },
    {
      title: 'Samples',
      data: [
        {
          instrument: 'Samples',
          core: false,
          pro: true,
          ultimate: true,
          lifetime: '$19.99 Each',
        },
      ],
    },
    {
      title: 'Apps',
      data: [
        {
          instrument: 'Zenbeats Max Unlock',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: 'Beat Sync Maker',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: '4xCamera',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: '4xCamera Maker',
          core: true,
          pro: true,
          ultimate: true,
          lifetime: null,
        },
        {
          instrument: 'R-MIX (Windows)',
          core: false,
          pro: false,
          ultimate: true,
          lifetime: null,
        },
      ],
    },
  ],
};

export const PURCHASE_TAG = 'rcw-memberships';

export const UPGRADE_DISCLAIMERS = {
  en: {
    warning:
  <p>
    <b>Warning:</b>
    {' '}
    If your subscription is in the trial period, you will lose the remaining trial days(today will be the last day), and then will be charged with the new subscription pricing.
  </p>,
    note:
  <p>
    Please note selecting "Change Now” will charge your default payment method immediately. The remainder of your current membership will be prorated towards the change. If you would like to use a different payment method update your information
    {' '}
    <a href={`${window.location.origin}${process.env.REACT_APP_DETAILS_REDIRECT}`}>here</a>
    {' '}
    prior to upgrading.
  </p>,
  },
  ja: {
    warning:
  <p>
    <b>ご注意：</b>
    サブスクリプションがトライアル期間中の場合、残りのトライアル日数は失われ（本日が最終日になります）、新しいサブスクリプション料金が請求されます。
  </p>,
    note:
  <p>
    「今すぐ変更」を選択すると、デフォルト設定のお支払い方法で即時に請求されますのでご注意ください。
    現在のメンバーシップの残額は、変更後の金額に按分されます。
    異なるお支払い方法をご利用になりたい場合は、アップグレード前に
    <a href={`${window.location.origin}${process.env.REACT_APP_DETAILS_REDIRECT}`}>こちら</a>
    で情報を更新してください。
  </p>,
  },
};

export const SUPPORT_LINK = `${window.location.origin}${process.env.REACT_APP_SUPPORT_PATH}`;
